var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-align-center flex-justify-center flex-direction-column row-gap-8"},[_c('img',{attrs:{"src":`${_vm.$cdn}dist/assets/cm/analytics-icon.svg`}}),_c('span',{staticClass:"fs-14 color-gray-800 fw-400"},[_vm._v("You do not have enough data yet.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }